import React from "react";

function Error() {
  return (
    <div className="main-content">
      <main>
        <h1>
          Oops! Seems like you followed some shady link or the page you are
          looking for is not unavailable. Please use the top navigation menu!
        </h1>
      </main>
    </div>
  );
}

export default Error;
